import React from "react";
import "./PendingVerification.css";
import { useLoaderData } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import DatePicker from "react-datepicker";
import LoaderSmall from "../../../Shared/LoderSmall/LoaderSmall";

const PendingVerificationDetails = () => {
  const AllShortedData = useLoaderData();
  /////////////////////////// DETAILS UPDATE START /////////////////////////////////
  const [checkedItemsFive, setCheckedItemsFive] = useState([]);

  const [date, setDate] = useState(new Date());

  const handleCalendarClose = () => console.log("Calendar closed");
  const handleCalendarOpen = () => console.log("Calendar opened");

  console.log(date);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedCategory, setCategory] = useState(null);
  const [profileData, setProfileData] = useState([]);
  // Loading state
  const [selectedLocation, setLocation] = useState(null);
  const [selectedAreaTwo, setAreaTwo] = useState(null);

  const [formData, setFormData] = useState({
    tittle: AllShortedData.tittle,
    gender: AllShortedData.gender,
    tutorGender: AllShortedData.tutorGender,
    numberOfStudents: AllShortedData.numberOfStudents,
    teachingDays: AllShortedData.teachingDays,
    TutoringTime: AllShortedData.TutoringTime,
    salary: AllShortedData.salary,
    required: AllShortedData.required,
    aboutUs: AllShortedData.aboutUs,
    AddressDetails: AllShortedData.AddressDetails,
    Institute: AllShortedData.Institute,
    requirement: AllShortedData.requirement,
    joiningDate: date.toString(),
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // ... other event handlers

  const [districts, setDistricts] = useState([]);
  const [Area, setArea] = useState([]);

  const fetchDistricts = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allDistrict");
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  ////////////////////////////////// khulna and chittagong area start ///////////////////////////////
  const [KhulnaArea, setKhulnaArea] = useState([]);
  const fetchKhulnaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
      const data = await response.json();
      setKhulnaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchKhulnaArea();
  }, []);
  const [ChittagongArea, setChittagongArea] = useState([]);
  const fetchChittagongArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
      const data = await response.json();
      setChittagongArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchChittagongArea();
  }, []);

  const [DhakaArea, setDhakaArea] = useState([]);
  const fetchDhakaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
      const data = await response.json();
      setDhakaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDhakaArea();
  }, []);
  ////////////////////////////////// khulna and chittagong area end   ///////////////////////////////

  const fetchArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allArea");
      const data = await response.json();
      setArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchArea();
  }, []);

  console.log(profileData);

  const [isUploading, setIsUploading] = useState(false);

  const handleSubmit = () => {
    const jobId = AllShortedData.jobId;

    const updatedFormData = {
      ...formData,
      jobId: jobId,
      joiningDate: date.toString(),
      requiredSubject1: checkedItemsFive[0] || "",
      requiredSubject2: checkedItemsFive[1] || "",
      requiredSubject3: checkedItemsFive[2] || "",
      requiredSubject4: checkedItemsFive[3] || "",
      requiredSubject5: checkedItemsFive[4] || "",
      ...(selectedLocation && { city: selectedLocation }),
      ...(selectedAreaTwo && { area: selectedAreaTwo }),
      ...(selectedCategory && { category: selectedCategory }),
      ...(selectedOption && { class: selectedOption }),
    };

    // Set loading state to true
    setIsUploading(true);
    console.log("update Data", updatedFormData);

    fetch("https://tutor-tree-server-1.vercel.app/allTutorsLeads/updateDetails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedFormData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response from the server
        console.log("Response from server:", data);

        // Show a success toast
        toast.success("Uploaded successfully!");
      })
      .catch((error) => {
        console.error("Error sending POST request:", error);
      })
      .finally(() => {
        // Set loading state to false after the request is completed
        setIsUploading(false);
      });
  };

  const classMapping = {
    "Pre-Schooling": "Pre-Schooling",
    Play: "Play",
    Nursery: "Nursery",
    KG: "KG",
    BM1: "Class 1",
    BM2: "Class 2",
    BM3: "Class 3",
    BM4: "Class 4",
    BM5: "Class 5",
    BM6: "Class 6",
    BM7: "Class 7",
    BM8: "Class 8",
    BM9: "Class 9",
    BM10: "Class 10",
    "BMHSC-1stYear": "HSC-1st Year",
    "BMHSC-2stYear": "HSC-2nd Year",
    EV1: "Class 1",
    EV2: "Class 2",
    EV3: "Class 3",
    EV4: "Class 4",
    EV5: "Class 5",
    EV6: "Class 6",
    EV7: "Class 7",
    EV8: "Class 8",
    EV9: "Class 9",
    EV10: "Class 10",
    "EVHSC-1stYear": "HSC-1st Year",
    "EVHSC-2stYear": "HSC-2nd Year",
    EM1: "Class 1",
    EM2: "Class 2",
    EM3: "Class 3",
    EM4: "Class 4",
    EM5: "Class 5",
    EM6: "Class 6",
    EM7: "Class 7",
    EM8: "Class 8",
    EM9: "Class 9",
    OLevel: "OLevel",
    ALevelAS: "A Level (AS)",
    ALevelA2: "A Level (A2)",
    "EMHSC-2stYear": "HSC-2nd Year",
    Alim1: "Class 1",
    Alim2: "Class 2",
    Alim3: "Class 3",
    Alim4: "Class 4",
    Alim5: "Class 5",
    Alim6: "Class 6",
    Alim7: "Class 7",
    Alim8: "Class 8",
    Alim9: "Class 9",
    Alim10: "Class 10",
    "Alim-1stYear": "Alim-1st Year",
    "Alim-2stYear": "Alim-2nd Year",
    IslamicStudies: "Islamic Studies",
    HinduismStudies: "Hinduism Studies",
    BuddhismStudies: "Buddhism Studies",
    ChristianityStudies: "Christianity Studies",
    SchoolAdmissionTest: "School Admission Test",
    PublicUniversityAdmissionTest: "Public University Admission Test",
    PrivateUniversityAdmissionTest: "Private University Admission Test",
    MedicalCollegeAdmissionTest: "Medical College Admission Test",
    EngineeringUniversityAdmissionTest: "Engineering University Admission Test",
    Arts: "Arts",
    Music: "Music",
    InstrumentalMusic: "Instrumental Music",
    Dance: "Dance",
    Crafting: "Crafting",
    Recitation: "Recitation",
    TestPreparation: "Test Preparation",
    IELTS: "IELTS",
    TOEFL: "TOEFL",
    GRE: "GRE",
    GMAT: "GMAT",
    SAT: "SAT",
    GED: "GED",
  };

  const subjects = [
    "All",
    "Bangla",
    "English",
    "Biology",
    "Physics",
    "Chemistry",
    "Higher Math",
    "ICT",
    "Business Studies",
    "Business Administration",
    "Accounting",
    "Finance",
    "Home Economics",
    "Management",
    "Marketing",
    "Finance and Banking",
    "Economics",
    "Civics",
    "Geography",
    "Psychology",
    "Religious Studies",
    "Statistics",
    "Sociology",
    "Commercial Geography",
    "Production Management and Marketing",
    "Agricultural Education",
    "Logic",
    "Social Work",
    "Islamic History and Culture",
    "History",
    "Political Science",
    "Engineering Drawing",
    "Maths",
    "General Science",
    "Business Entrepreneurship",
    "Electrical and Electronic Engineering",
    "Physical Education, Health & Sports",
    "Bangladesh & Global Studies",
    "Social Science",
    "Drawing",
    "Arts and craft",
    "Bangladesh Studies",
    "English Literature",
    "Others",
  ];
  const handleChangeFive = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsFive((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsFive((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const handleRemoveFive = (itemToRemove) => {
    setCheckedItemsFive((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputFive = checkedItemsFive.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemoveFive(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));
  /////////////////////////// DETAILS UPDATE END   /////////////////////////////////

  const [ShortListed, setShortListed] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMainShortListed = async () => {
    try {
      const response = await fetch(
        "https://tutor-tree-server-1.vercel.app/pendingVerificationMainData"
      );
      const data = await response.json();
      setShortListed(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchMainShortListed();
  }, []);

  const mainShortedData = ShortListed.filter(
    (item) => item.StudentsJobID === AllShortedData.jobId
  );
  console.log(mainShortedData);

  const [showItemCount, setShowItemCount] = useState(3);

  const handleShowMore = () => {
    setShowItemCount((prevCount) => prevCount + 3);
  };

  const handleShowLess = () => {
    setShowItemCount((prevCount) => Math.max(prevCount - 3, 3));
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleButtonClick = (apply) => {
    setSelectedItem(apply);
    setIsOpen(!isOpen);
  };

  const handleShortlistedArchive = (id) => {
    // Make admin
    fetch(
      `https://tutor-tree-server-1.vercel.app/shortlistedMainData/ShortlistedArchive/${id}`,
      {
        method: "PUT",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("shortlisted successful.");

          // Re-fetch the updated user data
          fetchMainShortListed();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };

  const archiveData = mainShortedData.filter(
    (item) => item.ShortListedArchive === "ShortListedArchive"
  );
  console.log(archiveData);

  //

  const [isOpenTwo, setIsOpenTwo] = useState(
    new Array(mainShortedData.length).fill(false)
  );

  const toggleDropdown = (index) => {
    const newIsOpen = [...isOpenTwo];
    newIsOpen[index] = !newIsOpen[index];
    setIsOpenTwo(newIsOpen);
  };

  const handlePendingConfirmation = (id) => {
    fetch(
      `https://tutor-tree-server-1.vercel.app/shortlistedMainData/PendingConfirmation/${id}`,
      {
        method: "PUT",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Pending Confirmation Successful.");

          // Re-fetch the updated user data
          fetchMainShortListed();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const handlePendingVerification = (id) => {
    fetch(
      `https://tutor-tree-server-1.vercel.app/shortlistedMainData/PendingVerification/${id}`,
      {
        method: "PUT",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Pending Verification Successful.");

          // Re-fetch the updated user data
          fetchMainShortListed();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const handleFollowUpTutor = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/shortlistedMainData/FollowUpTutor/${id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Follow Up Tutor Successful.");

          // Re-fetch the updated user data
          fetchMainShortListed();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const handleFollowUpGuardian = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/shortlistedMainData/FollowUpGuardian/${id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Follow Up Guardian Successful.");

          // Re-fetch the updated user data
          fetchMainShortListed();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const handlePrint = () => {
    const printContents = document.getElementById("admissionForm").innerHTML;

    // Open a new window with the printable content
    const printWindow = window.open("", "_blank");
    printWindow.document.write("<html><head><title>Print</title>");

    // Include a style element to set the font size to 16px
    printWindow.document.write(
      '<style type="text/css">body { font-size: 8px; }</style>'
    );

    printWindow.document.write("</head><body>");
    printWindow.document.write(printContents);
    printWindow.document.write("</body></html>");
    printWindow.document.close();

    // Print the contents in the new window
    printWindow.print();

    // Close the new window after printing
    printWindow.onafterprint = () => {
      printWindow.close();
      setIsOpen(true);
    };
  };
  const [selectedReason, setSelectedReason] = useState("");

  const handleMakeCancelled = (id, selectedReason) => {
    if (!selectedReason) {
      toast.error("Please select a reason before submitting.");
      return;
    }

    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/cancelled/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ reason: selectedReason }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Archived successful.");
          setModalOpen(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItemTwo, setSelectedItemTwo] = useState(null);

  const handleButtonClickTwo = (apply) => {
    setSelectedItemTwo(apply);
    setModalOpen(!isModalOpen);
  };


 // Archive start ///
 const [isButtonClickedArchive, setIsButtonClickedArchive] = useState(
  Array(ShortListed.length).fill(false)
);
const handleClickArchive = (index) => {
  const newButtonState = [...isButtonClickedArchive];
  newButtonState[index] = !newButtonState[index];
  setIsButtonClickedArchive(newButtonState);
  fetchMainShortListed();
};

const handleCombinedClick = (id, buttonIndex, apply) => {
  // Make admin
  fetch(`https://tutor-tree-server-1.vercel.app/allTutorsLeads/archive/${id}`, {
    method: "PUT",
  })
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      if (data.modifiedCount > 0) {
        toast.success("archived successful.");
        // Re-fetch the updated user data
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      // Handle any errors that occur during the request
    });

  // Handle archive click
  handleClickArchive(buttonIndex);
  fetchMainShortListed();
};
// Archive End ///

  return (
    <div>
      <div className="border-2 border-gray-100 rounded-lg m-5">
        <div className="w-full py-5 flex justify-between items-center border-b-2 border-gray-200 px-5">
          <div>
            <div>
              <h1 className="tittleMainLeadsDetails">
                {AllShortedData.tittle}
              </h1>
            </div>
            <div className="flex flex-row items-center mt-5">
              <div>
                <h1 className="MainLeadsDetailsPera">
                  Job Id : {AllShortedData.jobId}
                </h1>
              </div>
              <div className="ml-3">|</div>
              <div className="ml-3">
                <h1 className="MainLeadsDetailsPera">
                  Posted Date :{" "}
                  {new Date(AllShortedData.postedDate).toLocaleDateString(
                    "en-GB"
                  )}
                </h1>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={() => {
                handleButtonClickTwo(AllShortedData);
              }}
              className=""
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="25"
                viewBox="0 0 27 25"
                fill="none"
              >
                <path
                  d="M26.6667 12.5C26.6667 15.7165 24.0494 18.3333 20.8333 18.3333H16.6667C16.206 18.3333 15.8333 17.9602 15.8333 17.5C15.8333 17.0398 16.206 16.6667 16.6667 16.6667H20.8333C23.1306 16.6667 25 14.7973 25 12.5C25 10.2027 23.1306 8.33333 20.8333 8.33333H20C19.5394 8.33333 19.1667 7.96021 19.1667 7.5C19.1667 4.28354 16.5494 1.66667 13.3333 1.66667C10.1173 1.66667 7.5 4.28354 7.5 7.5C7.5 7.96021 7.12729 8.33333 6.66667 8.33333H5.83333C3.53604 8.33333 1.66667 10.2027 1.66667 12.5C1.66667 14.7973 3.53604 16.6667 5.83333 16.6667H10C10.4606 16.6667 10.8333 17.0398 10.8333 17.5C10.8333 17.9602 10.4606 18.3333 10 18.3333H5.83333C2.61729 18.3333 0 15.7165 0 12.5C0 9.28354 2.61729 6.66667 5.83333 6.66667H5.87979C6.29563 2.92187 9.47917 0 13.3333 0C17.1875 0 20.371 2.92187 20.7869 6.66667H20.8333C24.0496 6.66667 26.6667 9.28354 26.6667 12.5ZM16.0775 20.2442L14.1667 22.155V11.6667C14.1667 11.2065 13.794 10.8333 13.3333 10.8333C12.8727 10.8333 12.5 11.2065 12.5 11.6667V22.155L10.5892 20.2442C10.2635 19.9185 9.73625 19.9185 9.41083 20.2442C9.08542 20.5698 9.08521 21.0971 9.41083 21.4225L12.7442 24.7558C12.9069 24.9185 13.1202 25 13.3333 25C13.5465 25 13.7598 24.9185 13.9225 24.7558L17.2558 21.4225C17.5815 21.0969 17.5815 20.5696 17.2558 20.2442C16.9302 19.9187 16.4029 19.9185 16.0775 20.2442Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="px-5 mt-5">
        <h1 className="MainLeadsDetailsPera">
          Name : {AllShortedData.posterName} {AllShortedData.name}
        </h1>
        <h1 className="MainLeadsDetailsPera">Email : {AllShortedData.email}</h1>
        <h1 className="MainLeadsDetailsPera">
          Number : {AllShortedData.posterPhone}
        </h1>
      </div>
      <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5 px-5 mt-5">
        <div className="">
          <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center textMain">
            Select City
          </div>

          <select
            required
            // name="district"
            // value={selectedLocation}
            // onChange={handleInputChange}
            onChange={(e) => setLocation(e.target.value)}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
              {AllShortedData.city}
            </option>
            {districts.map((district, index) => (
              <option key={index} value={district.district}>
                {district.district}
              </option>
            ))}
          </select>
        </div>
        <div className="">
          {selectedLocation === "Chittagong" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
                Select Area
              </div>
              <select
                // name="city"
                // value={selectedAreaTwo}
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setAreaTwo(e.target.value)}
              >
                <option disabled selected>
                  {AllShortedData.area}
                </option>
                {ChittagongArea.map((area, index) => (
                  <option key={index} value={area.area}>
                    {area.area}
                  </option>
                ))}
              </select>
            </div>
          )}
          {selectedLocation === "Khulna" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
                Select Area
              </div>
              <select
                // name="area"
                // value={selectedAreaTwo}
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setAreaTwo(e.target.value)}
              >
                <option disabled selected>
                  {AllShortedData.area}
                </option>
                {KhulnaArea.map((area, index) => (
                  <option key={index} value={area.area}>
                    {area.area}
                  </option>
                ))}
              </select>
            </div>
          )}
          {selectedLocation === "Dhaka" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
                Select Area
              </div>
              <select
                // name="area"
                // value={selectedAreaTwo}
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setAreaTwo(e.target.value)}
              >
                <option disabled selected>
                  {AllShortedData.area}
                </option>
                {DhakaArea.map((area, index) => (
                  <option key={index} value={area.area}>
                    {area.area}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-48 flex justify-center items-center textMain">
            Tutor Gender Preference
          </div>

          <select
            required
            name="tutorGender"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
              {AllShortedData.tutorGender}
            </option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="others">Any</option>
          </select>
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-28 flex justify-center items-center textMain">
            Days / Week
          </div>

          <select
            required
            name="teachingDays"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
              {AllShortedData.teachingDays}
            </option>

            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-40 flex justify-center items-center textMain">
            Number of Students
          </div>

          <select
            required
            name="numberOfStudents"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
              Select number of students
            </option>
            <option disabled selected>
              {AllShortedData.numberOfStudents}
            </option>

            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
            Tutoring Time
          </div>

          <select
            required
            name="TutoringTime"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
              Select Tutoring Time
            </option>
            <option value="7AM">7AM</option>
            <option value="8AM">8AM</option>
            <option value="10AM">10AM</option>
            <option value="11AM">11AM</option>
            <option value="12AM">12AM</option>
            <option value="2PM">2PM</option>
            <option value="3PM">3PM</option>
            <option value="4PM">4PM</option>
            <option value="4.30PM">4.30PM</option>
            <option value="5PM">5PM</option>
            <option value="5.30PM">5.30PM</option>
            <option value="6PM">6PM</option>
            <option value="6.30PM">6.30PM</option>
            <option value="7PM">7PM</option>
            <option value="7.30PM">7.30PM</option>
            <option value="8PM">8PM</option>
            <option value="9PM">9PM</option>
            <option value="Negotiable">Negotiable</option>
          </select>
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-20 flex justify-center items-center textMain">
            Category
          </div>

          <select
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
            onChange={(e) => setCategory(e.target.value)}
          >
            <option disabled selected>
              {AllShortedData.category}
            </option>
            <option value="BanglaVersion">Bangla Version</option>
            <option value="EnglishVersion">English Version</option>
            <option value="EnglishMedium">English Medium </option>
            <option value="MadrasaMedium">Madrasa Medium</option>
            <option value="ReligiousStudies">Religious Studies</option>
            <option value="AdmissionTest">Admission Test</option>
            <option value="Arts">Arts</option>
            <option value="TestPreparation">Test Preparation </option>

            {/* Add more options as needed */}
          </select>
        </div>
        <div>
          {selectedCategory === "BanglaVersion" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                {" "}
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="Pre-Schooling">Pre-Schooling</option>
                <option value="Play">Play</option>
                <option value="Nursery">Nursery</option>
                <option value="KG">KG</option>
                <option value="BM1">Class 1</option>
                <option value="BM2">Class 2</option>
                <option value="BM3">Class 3</option>
                <option value="BM4">Class 4</option>
                <option value="BM5">Class 5</option>
                <option value="BM6">Class 6</option>
                <option value="BM7">Class 7</option>
                <option value="BM8">Class 8</option>
                <option value="BM9">Class 9</option>
                <option value="BM10">Class 10</option>
                <option value="BMHSC-1stYear">HSC-1st Year</option>
                <option value="BMHSC-2ndYear">HSC-2nd Year</option>
              </select>
            </div>
          )}

          {selectedCategory === "EnglishVersion" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="Pre-Schooling">Pre-Schooling</option>
                <option value="Play">Play</option>
                <option value="Nursery">Nursery</option>
                <option value="KG">KG</option>
                <option value="EV2">Class 1</option>
                <option value="EV2">Class 2</option>
                <option value="EV3">Class 3</option>
                <option value="EV4">Class 4</option>
                <option value="EV5">Class 5</option>
                <option value="EV6">Class 6</option>
                <option value="EV7">Class 7</option>
                <option value="EV8">Class 8</option>
                <option value="EV9">Class 9</option>
                <option value="EV10">Class 10</option>
                <option value="EVHSC-1stYear">HSC-1st Year</option>
                <option value="EVHSC-2ndYear">HSC-2nd Year</option>
              </select>
            </div>
          )}
          {selectedCategory === "EnglishMedium" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="Pre-Schooling">Pre-Schooling</option>
                <option value="Play">Play</option>
                <option value="Nursery">Nursery</option>
                <option value="KG">KG</option>
                <option value="EM1">Standard 1</option>
                <option value="EM2">Standard 2</option>
                <option value="EM3">Standard 3</option>
                <option value="EM4">Standard 4</option>
                <option value="EM5">Standard 5</option>
                <option value="EM6">Standard 6</option>
                <option value="EM7">Standard 7</option>
                <option value="EM8">Standard 8</option>
                <option value="EM9">Standard 9</option>
                <option value="OLevel">O Level</option>
                <option value="ALevelAS">A Level (AS)</option>
                <option value="ALevelA2">A Level (A2)</option>
              </select>
            </div>
          )}
          {selectedCategory === "MadrasaMedium" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="Play">Play</option>
                <option value="Nursery">Nursery</option>
                <option value="KG">KG</option>
                <option value="Alim1">Class 1</option>
                <option value="Alim2">Class 2</option>
                <option value="Alim3">Class 3</option>
                <option value="Alim4">Class 4</option>
                <option value="Alim5">Class 5</option>
                <option value="Alim6">Class 6</option>
                <option value="Alim7">Class 7</option>
                <option value="Alim8">Class 8</option>
                <option value="Alim9">Class 9</option>
                <option value="OLevel">O Level</option>
                <option value="Alim-1stYear">Class-1st Year</option>
                <option value="Alim-2stYear">Class-2st Year</option>
              </select>
            </div>
          )}
          {selectedCategory === "ReligiousStudies" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="IslamicStudies">Islamic Studies</option>
                <option value="HinduismStudies">Hinduism Studies</option>
                <option value="BuddhismStudies">Buddhism Studies</option>
                <option value="ChristianityStudies">
                  Christianity Studies
                </option>
              </select>
            </div>
          )}
          {selectedCategory === "AdmissionTest" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="SchoolAdmissionTest">
                  School Admission Test
                </option>
                <option value="PublicUniversityAdmissionTest">
                  Public University Admission Test
                </option>
                <option value="PrivateUniversityAdmissionTest">
                  Private University Admission Test
                </option>
                <option value="MedicalCollegeAdmissionTest">
                  Medical College Admission Test
                </option>
                <option value="EngineeringUniversityAdmissionTest">
                  Engineering University Admission Test
                </option>
              </select>
            </div>
          )}
          {selectedCategory === "Arts" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="DrawingAndPainting">Drawing and painting</option>
                <option value="Handwriting">Handwriting</option>
                <option value="Music">Music</option>
                <option value="InstrumentalMusic">Instrumental Music</option>
                <option value="Dance">Dance</option>
                <option value="Crafting">Crafting</option>
                <option value="Recitation">Recitation</option>
              </select>
            </div>
          )}
          {selectedCategory === "TestPreparation" && (
            <div>
              <div className="translate-y-3 ml-5 bg-white w-16 flex justify-center items-center textMain">
                Class
              </div>
              <select
                className="h-[60px] select border-2 border-orange-500 select-error w-full"
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option disabled selected>
                  {classMapping[AllShortedData.class] || AllShortedData.class}
                </option>
                <option value="IELTS">IELTS</option>
                <option value="TOEFL">TOEFL</option>
                <option value="GMAT">GMAT</option>
                <option value="GRE">GRE</option>
                <option value="SAT">SAT</option>
                <option value="GED">GED</option>
                <option value="BankJobPreparation">Bank Job Preparation</option>
              </select>
            </div>
          )}
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center textMain">
            Hire Date
          </div>

          <div className="w-full h-[60px] border-2 border-orange-500 rounded-lg  justify-between inline-flex bg-white ">
            <div className="flex justify-center items-center">
              <DatePicker
                required
                selected={date}
                onChange={(date) => setDate(date)}
                onCalendarClose={handleCalendarClose}
                onCalendarOpen={handleCalendarOpen}
                className="calenderMjrTwo"
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
              />
            </div>
            <div className="flex justify-center items-center mr-3">
              <h1 className="px-3">
                {new Date(AllShortedData.joiningDate).toLocaleDateString("en-GB")}
              </h1>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8.71094 0.78125H7.8125V0.3125C7.8125 0.139922 7.6726 0 7.5 0C7.3274 0 7.1875 0.139922 7.1875 0.3125V0.78125H2.8125V0.3125C2.8125 0.139922 2.6726 0 2.5 0C2.3274 0 2.1875 0.139922 2.1875 0.3125V0.78125H1.28906C0.578262 0.78125 0 1.35951 0 2.07031V8.71094C0 9.42174 0.578262 10 1.28906 10H8.71094C9.42174 10 10 9.42174 10 8.71094V2.07031C10 1.35951 9.42174 0.78125 8.71094 0.78125ZM9.375 8.71094C9.375 9.07769 9.07769 9.375 8.71094 9.375H1.28906C0.922305 9.375 0.625 9.07769 0.625 8.71094V3.53516C0.625 3.48123 0.66873 3.4375 0.722656 3.4375H9.27734C9.33127 3.4375 9.375 3.48123 9.375 3.53516V8.71094Z"
                  fill="#FE7702"
                />
              </svg>
            </div>
          </div>
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center ">
            <h1 className="textMain">Salary(BDT)</h1>
          </div>
          <input
            required
            type="number"
            name="salary"
            placeholder={AllShortedData.salary}
            className="input border-2 border-orange-500 h-[60px] input-warning w-full "
            onChange={handleInputChange}
          />
        </div>
        <div className="relative">
          <div className="translate-y-3 top-0 z-10 absolute ml-5 bg-white w-32 flex justify-center items-center textMain">
            Required Subject
          </div>
          <details className="dropdown w-full mt-5">
            <summary className="w-full selectTextMain cursor-pointer flex overflow-y-scroll justify-between px-4 items-center h-16 bg-white border-2 border-orange-500 hover:border-orange-500 rounded-lg hover:bg-white text-black">
              {checkedItemsFive.length > 0 ? (
                formattedOutputFive
              ) : (
                <h1 className="selectTextMain">
                  {AllShortedData.requiredSubject1}{" "}
                  {AllShortedData.requiredSubject2 ? "," : ""}{" "}
                  {AllShortedData.requiredSubject2}{" "}
                  {AllShortedData.requiredSubject3 ? "," : ""}{" "}
                  {AllShortedData.requiredSubject3}{" "}
                  {AllShortedData.requiredSubject4 ? "," : ""}{" "}
                  {AllShortedData.requiredSubject4}{" "}
                  {AllShortedData.requiredSubject5 ? "," : ""}{" "}
                  {AllShortedData.requiredSubject5}
                </h1>
              )}
              <svg
                id="Layer_1"
                enable-background="new 0 0 128 128"
                height="20"
                viewBox="0 0 128 128"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Down_Arrow_3_"
                  d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
                />
              </svg>
            </summary>
            <ul className="p-2 shadow menu dropdown-content z-[1] h-56 overflow-auto bg-base-100 rounded-box w-full">
              {subjects.map((subject) => (
                <div className="form-checkbox">
                  <div className="flex flex-row justify-start items-center">
                    <input
                      type="checkbox"
                      id={subject}
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={handleChangeFive}
                    />
                    <label className="ml-4 selectTextMain" htmlFor={subject}>
                      {subject}
                    </label>
                  </div>
                </div>
              ))}
            </ul>
          </details>
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-56 flex justify-center items-center textMain">
            How did you hear about us?
          </div>

          <select
            required
            name="aboutUs"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
              {AllShortedData.aboutUs}
            </option>
            <option value="Facebook">Facebook</option>
            <option value="Friends & Family">Friends & Family</option>
            <option value="Banner/Poster">Banner/Poster</option>
            <option value="YouTube">YouTube</option>
            <option value="Google Search">Google Search</option>
          </select>
        </div>

        <div>
          <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
            Student Gender
          </div>

          <select
            required
            name="gender"
            onChange={handleInputChange}
            className="h-[60px] select border-2 border-orange-500 select-error w-full "
          >
            <option disabled selected>
              {AllShortedData.gender}
            </option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>

        <div>
          <div className="translate-y-3 ml-5 bg-white w-20 flex justify-center items-center textMain">
            Institute
          </div>
          <input
            required
            type="text"
            name="Institute"
            placeholder={AllShortedData.Institute}
            className="input border-2 border-orange-500 h-[60px] input-warning w-full "
            onChange={handleInputChange}
          />
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
            Address Details
          </div>
          <input
            required
            type="text"
            name="AddressDetails"
            placeholder={AllShortedData.AddressDetails}
            className="input border-2 border-orange-500 h-[60px] input-warning w-full "
            onChange={handleInputChange}
          />
        </div>
        <div>
          <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
            Admin Reminder
          </div>
          <input
            type="text"
            name="additionInfo"
            placeholder={AllShortedData.additionInfo}
            className="input border-2 border-orange-500 h-[60px] input-warning w-full "
            onChange={handleInputChange}
          />
        </div>

        <div>
          <div className="translate-y-3 ml-5 bg-white w-56 flex justify-center items-center textMain">
            More about your requirement
          </div>
          <input
            type="text"
            name="req"
            placeholder={AllShortedData.req}
            className="input border-2 border-orange-500 h-[60px] input-warning w-full "
            onChange={handleInputChange}
          />
        </div>
      </div>
      <div className="flex mt-10 mx-5">
        <button
          onClick={handleSubmit}
          className="w-32 h-10 flex justify-center items-center bg-orange-500 text-white rounded my-5"
        >
          {isUploading ? <LoaderSmall /> : "Upload"}
        </button>
      </div>
      </div>
      <div className="grid grid-cols-3 mt-10 gap-10 mx-5">
        {mainShortedData.slice(0, showItemCount).map((apply, index) => (
          <div
            key={index}
            className="w-full  rounded-xl border-gray-200 border-2 px-6 py-8"
          >
            <div className="flex flex-col">
             <div className="flex flex-row justify-between">
             <div>
                <h1 className="MianCardText55 uppercase">
                  {apply.teacherName}
                </h1>
                <h2 className="MainPera666 text-left">
                  Job ID : {apply.StudentsJobID}
                </h2>
                <h2 className="MainPera666 text-left">
                  {apply.PendingData === "ShortListedFollowUp"
                    ? "Follow Up"
                    : apply.PendingData === "PendingConfirmation"
                    ? "Pending Confirmation"
                    : apply.PendingData === "PendingVerification"
                    ? "Pending Verification"
                    : "Status"}
                </h2>
              </div>
              <div>
        <button onClick={() => handleCombinedClick(apply._id, apply)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
          >
            <g opacity="0.3">
              <path
                d="M21.3333 10C21.3333 12.5732 19.2395 14.6667 16.6667 14.6667H13.3333C12.9648 14.6667 12.6667 14.3682 12.6667 14C12.6667 13.6318 12.9648 13.3333 13.3333 13.3333H16.6667C18.5045 13.3333 20 11.8378 20 10C20 8.16217 18.5045 6.66667 16.6667 6.66667H16C15.6315 6.66667 15.3333 6.36817 15.3333 6C15.3333 3.42683 13.2395 1.33333 10.6667 1.33333C8.09383 1.33333 6 3.42683 6 6C6 6.36817 5.70183 6.66667 5.33333 6.66667H4.66667C2.82883 6.66667 1.33333 8.16217 1.33333 10C1.33333 11.8378 2.82883 13.3333 4.66667 13.3333H8C8.3685 13.3333 8.66667 13.6318 8.66667 14C8.66667 14.3682 8.3685 14.6667 8 14.6667H4.66667C2.09383 14.6667 0 12.5732 0 10C0 7.42683 2.09383 5.33333 4.66667 5.33333H4.70383C5.0365 2.3375 7.58333 0 10.6667 0C13.75 0 16.2968 2.3375 16.6295 5.33333H16.6667C19.2397 5.33333 21.3333 7.42683 21.3333 10ZM12.862 16.1953L11.3333 17.724V9.33333C11.3333 8.96517 11.0352 8.66667 10.6667 8.66667C10.2982 8.66667 10 8.96517 10 9.33333V17.724L8.47133 16.1953C8.21083 15.9348 7.789 15.9348 7.52867 16.1953C7.26833 16.4558 7.26817 16.8777 7.52867 17.138L10.1953 19.8047C10.3255 19.9348 10.4962 20 10.6667 20C10.8372 20 11.0078 19.9348 11.138 19.8047L13.8047 17.138C14.0652 16.8775 14.0652 16.4557 13.8047 16.1953C13.5442 15.935 13.1223 15.9348 12.862 16.1953Z"
                fill={isButtonClickedArchive[index] ? "#000000" : "#14532d"}
              />
            </g>
          </svg>
        </button>
              </div>
             </div>
              <div>
                <div className="flex flex-col">
                  <button
                    onClick={() => handlePendingConfirmation(apply._id)}
                    className="mt-3 confirmationBtn"
                  >
                    Pending Confirmation
                  </button>
                  <button
                    onClick={() => handlePendingVerification(apply._id)}
                    className="mt-3 VerificationBtn"
                  >
                    Pending Verification
                  </button>
                  <button
                    onClick={() => handleFollowUpTutor(apply._id)}
                    className="mt-3 FollowUpBtn"
                  >
                    Follow Up Tutor
                  </button>
                  <button
                    onClick={() => handleFollowUpGuardian(apply._id)}
                    className="mt-3 FollowUpBtn"
                  >
                    Follow Up Guardian
                  </button>
                </div>
                {/* <button
                                    onClick={() => toggleDropdown(index)}
                                    className="w-48 h-10 bg-gray-200 text-gray-900 rounded-lg"
                                >
                                 
                                </button> */}
                {/* {isOpenTwo[index] && (
                                    <div className="absolute z-10 mt-2 w-48 px-2 py-2 bg-white border border-gray-200 rounded-md shadow-lg">
                                       
                                    </div>
                                )} */}
              </div>
              {/* <div className='flex flex-row justify-center items-center'>
                                    <div>
                                        <button onClick={() => handleShortlistedArchive(apply._id)} >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                                <g opacity="0.3">
                                                    <path d="M21.3333 10C21.3333 12.5732 19.2395 14.6667 16.6667 14.6667H13.3333C12.9648 14.6667 12.6667 14.3682 12.6667 14C12.6667 13.6318 12.9648 13.3333 13.3333 13.3333H16.6667C18.5045 13.3333 20 11.8378 20 10C20 8.16217 18.5045 6.66667 16.6667 6.66667H16C15.6315 6.66667 15.3333 6.36817 15.3333 6C15.3333 3.42683 13.2395 1.33333 10.6667 1.33333C8.09383 1.33333 6 3.42683 6 6C6 6.36817 5.70183 6.66667 5.33333 6.66667H4.66667C2.82883 6.66667 1.33333 8.16217 1.33333 10C1.33333 11.8378 2.82883 13.3333 4.66667 13.3333H8C8.3685 13.3333 8.66667 13.6318 8.66667 14C8.66667 14.3682 8.3685 14.6667 8 14.6667H4.66667C2.09383 14.6667 0 12.5732 0 10C0 7.42683 2.09383 5.33333 4.66667 5.33333H4.70383C5.0365 2.3375 7.58333 0 10.6667 0C13.75 0 16.2968 2.3375 16.6295 5.33333H16.6667C19.2397 5.33333 21.3333 7.42683 21.3333 10ZM12.862 16.1953L11.3333 17.724V9.33333C11.3333 8.96517 11.0352 8.66667 10.6667 8.66667C10.2982 8.66667 10 8.96517 10 9.33333V17.724L8.47133 16.1953C8.21083 15.9348 7.789 15.9348 7.52867 16.1953C7.26833 16.4558 7.26817 16.8777 7.52867 17.138L10.1953 19.8047C10.3255 19.9348 10.4962 20 10.6667 20C10.8372 20 11.0078 19.9348 11.138 19.8047L13.8047 17.138C14.0652 16.8775 14.0652 16.4557 13.8047 16.1953C13.5442 15.935 13.1223 15.9348 12.862 16.1953Z"
                                                        fill='#000000'
                                                    />
                                                </g>
                                            </svg>
                                        </button>

                                    </div>
                                    <div className='ml-3'>

                                   
                                    </div>
                                </div> */}
            </div>
            <button onClick={() => handleButtonClick(apply)}>
              <div className="flex flex-row mt-5 items-center ">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="14"
                    viewBox="0 0 11 14"
                    fill="none"
                  >
                    <path
                      d="M5.16307 6.17603e-05C5.18719 6.75331e-05 5.2113 7.33056e-05 5.23615 7.92533e-05C5.61827 0.000991197 5.9819 0.0260035 6.35384 0.11948C6.37581 0.124736 6.39777 0.129992 6.4204 0.135407C7.259 0.338523 8.03645 0.761437 8.668 1.34757C8.71036 1.38591 8.75421 1.42263 8.79905 1.45803C8.85698 1.50502 8.90382 1.55056 8.95205 1.6071C8.97628 1.63549 8.97628 1.63549 9.00099 1.66446C9.01918 1.68606 9.03737 1.70767 9.05612 1.72993C9.07797 1.75547 9.09982 1.78102 9.12233 1.80733C9.97726 2.81664 10.4494 4.13931 10.3556 5.46747C10.28 6.3076 10.0082 7.10834 9.60203 7.84416C9.59014 7.86578 9.57825 7.88741 9.566 7.90969C9.3368 8.32024 9.06572 8.70675 8.80395 9.09688C8.6076 9.38954 8.41384 9.68389 8.22019 9.97834C7.98247 10.3396 7.74397 10.7004 7.50367 11.0599C7.33059 11.319 7.15855 11.5786 6.9889 11.8399C6.79731 12.1347 6.60363 12.428 6.41014 12.7216C6.39281 12.7479 6.37548 12.7741 6.35763 12.8012C6.26092 12.948 6.16415 13.0947 6.06726 13.2413C6.03066 13.2967 5.99413 13.3522 5.95762 13.4076C5.93858 13.4364 5.91955 13.4652 5.89995 13.4949C5.88441 13.5185 5.86887 13.542 5.85286 13.5663C5.72865 13.7447 5.59139 13.9315 5.3712 13.9857C5.18439 14.0065 4.98645 14.019 4.82113 13.9172C4.64203 13.7726 4.51738 13.5976 4.39911 13.4031C4.26958 13.1931 4.13436 12.9874 3.9968 12.7826C3.92553 12.6765 3.8545 12.5702 3.78346 12.4638C3.76845 12.4414 3.75344 12.4189 3.73797 12.3958C3.55666 12.1242 3.37726 11.8513 3.19778 11.5785C2.96005 11.2173 2.72156 10.8565 2.48127 10.497C2.30808 10.2378 2.13573 9.97811 1.96626 9.71645C1.86413 9.55906 1.76097 9.40241 1.65709 9.24617C1.58713 9.14096 1.51731 9.03566 1.44748 8.93036C1.41287 8.87825 1.3782 8.82619 1.34346 8.77418C0.433149 7.41101 -0.23056 5.90818 0.0756238 4.23633C0.267161 3.28043 0.69435 2.39694 1.35852 1.68131C1.39685 1.63895 1.43358 1.5951 1.46898 1.55026C1.51597 1.49233 1.56151 1.44548 1.61804 1.39726C1.63697 1.38111 1.6559 1.36496 1.67541 1.34832C1.69701 1.33013 1.71861 1.31194 1.74087 1.29319C1.76642 1.27134 1.79196 1.24949 1.81828 1.22698C2.53033 0.623845 3.36257 0.234078 4.27937 0.064889C4.31658 0.0575989 4.31658 0.0575989 4.35454 0.0501616C4.62386 0.00235658 4.89042 -0.000540214 5.16307 6.17603e-05ZM2.42327 1.56615C2.39793 1.5854 2.3726 1.60464 2.3465 1.62447C1.41853 2.35417 0.875263 3.38993 0.676342 4.54138C0.671543 4.56725 0.666745 4.59312 0.661801 4.61978C0.532246 5.487 0.769518 6.3673 1.12501 7.15153C1.13642 7.1767 1.14782 7.20187 1.15957 7.22781C1.33042 7.59054 1.55418 7.92501 1.77499 8.25871C1.79945 8.29581 1.82391 8.33292 1.84836 8.37003C1.90172 8.451 1.95512 8.53194 2.00857 8.61286C2.10186 8.75416 2.19491 8.89561 2.28796 9.03706C2.60692 9.5218 2.9267 10.006 3.24905 10.4884C3.40972 10.729 3.56914 10.9702 3.72668 11.2128C3.94816 11.5535 4.17192 11.8927 4.39596 12.2317C4.4301 12.2833 4.46424 12.335 4.49838 12.3867C4.51496 12.4117 4.53155 12.4368 4.54864 12.4627C4.63314 12.5907 4.71723 12.7189 4.80036 12.8478C4.83161 12.8962 4.86299 12.9446 4.89444 12.9929C4.93023 13.0479 4.96573 13.1032 5.00089 13.1587C5.0238 13.1938 5.0238 13.1938 5.04717 13.2295C5.05986 13.2493 5.07254 13.2691 5.08561 13.2895C5.09879 13.3031 5.11196 13.3166 5.12554 13.3306C5.23031 13.3434 5.23031 13.3434 5.27117 13.2946C5.28191 13.2777 5.29265 13.2608 5.30372 13.2433C5.31619 13.2241 5.32865 13.2049 5.3415 13.1852C5.35475 13.1639 5.368 13.1427 5.38165 13.1209C5.41098 13.0754 5.44031 13.0299 5.46964 12.9844C5.49247 12.9485 5.49247 12.9485 5.51576 12.912C5.59131 12.7939 5.66894 12.6772 5.7463 12.5602C5.77823 12.5118 5.81014 12.4633 5.84204 12.4148C6.11948 11.993 6.3975 11.5718 6.67798 11.1521C6.85134 10.8926 7.02361 10.6325 7.19359 10.3708C7.35993 10.115 7.52769 9.8601 7.69557 9.60528C7.73026 9.55262 7.76495 9.49995 7.79962 9.44728C7.97423 9.18209 8.14911 8.91713 8.3266 8.65386C8.86377 7.85675 9.36259 7.0661 9.60203 6.12453C9.60816 6.10049 9.61428 6.07646 9.62059 6.05169C9.77564 5.41402 9.75976 4.73984 9.60203 4.10465C9.59692 4.08375 9.59181 4.06284 9.58654 4.0413C9.51294 3.74898 9.40537 3.47506 9.27448 3.20389C9.26636 3.18695 9.25824 3.17 9.24988 3.15254C9.03425 2.70928 8.74434 2.32712 8.40102 1.97559C8.37284 1.94439 8.37284 1.94439 8.34408 1.91257C8.02796 1.57208 7.61211 1.31112 7.20001 1.10212C7.16978 1.08678 7.13956 1.07144 7.10842 1.05564C5.59354 0.32495 3.74589 0.542773 2.42327 1.56615Z"
                      fill="#A4A4A4"
                    />
                    <path
                      d="M6.02709 2.54857C6.05854 2.55877 6.09 2.56897 6.12241 2.57949C6.4478 2.6951 6.72045 2.87222 6.98243 3.09448C7.00056 3.10862 7.01868 3.12277 7.03735 3.13734C7.52336 3.5297 7.83966 4.17267 7.91049 4.78681C7.99116 5.54621 7.82149 6.28408 7.33728 6.88858C6.84777 7.47634 6.20503 7.83024 5.44215 7.91718C4.75476 7.9781 4.01592 7.78766 3.47611 7.34715C3.40574 7.28702 3.33787 7.22472 3.27022 7.16154C3.24315 7.13773 3.24315 7.13773 3.21552 7.11345C2.70634 6.64444 2.45299 5.92771 2.42406 5.25084C2.41469 4.48573 2.69406 3.77478 3.22249 3.22365C3.94673 2.50609 5.05298 2.22667 6.02709 2.54857ZM3.65236 3.72228C3.63618 3.73833 3.61999 3.75437 3.60331 3.7709C3.19722 4.19273 3.06361 4.7428 3.0718 5.313C3.08947 5.84031 3.33051 6.33206 3.70695 6.69751C4.11638 7.0744 4.64747 7.30321 5.20822 7.29802C5.81065 7.2637 6.32885 7.03037 6.75394 6.59707C7.17403 6.12375 7.3244 5.56216 7.28866 4.93807C7.24669 4.45047 6.98314 3.97055 6.62759 3.64039C6.61155 3.62421 6.5955 3.60802 6.57897 3.59135C6.16291 3.19081 5.61524 3.05088 5.05105 3.05983C4.521 3.07937 4.01114 3.3359 3.65236 3.72228Z"
                      fill="#A4A4A4"
                    />
                  </svg>
                </div>
                <div className="flex flex-col items-center justify-start ml-3">
                  <div className="w-full ">
                    <p className="text-left textCardHeading156">Location</p>
                  </div>
                  <div className="w-full mt-1">
                    <p className="text-left textPera156">
                      {apply.StudentsDistrict}, {apply.StudentsArea}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-row mt-8 items-center">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M10.5913 0.422955C10.5913 0.738097 10.5944 0.849019 10.6038 0.858349C10.6131 0.867679 10.7313 0.870789 11.0703 0.870789C11.4393 0.870789 11.5243 0.872862 11.5243 0.884266C11.5243 0.898779 11.3968 1.02525 11.1718 1.23465C10.9915 1.40363 10.9251 1.46686 10.7935 1.59541C10.7313 1.65657 10.6494 1.73432 10.6121 1.76749C10.5747 1.80067 10.4493 1.91988 10.3322 2.03184C10.215 2.1438 10.0844 2.26716 10.0419 2.30655C9.99939 2.34595 9.90817 2.43199 9.83975 2.4973C9.77133 2.56364 9.70498 2.62584 9.69358 2.63621C9.67181 2.65383 9.66974 2.6528 9.57955 2.56986C9.42094 2.4237 9.40643 2.41126 9.33697 2.35942C9.29965 2.33143 9.26544 2.30344 9.25922 2.29619C9.22916 2.26094 8.77407 1.96964 8.74919 1.96964C8.74297 1.96964 8.66937 1.93439 8.58436 1.89189C8.49936 1.84939 8.42057 1.81414 8.40917 1.81414C8.39776 1.81414 8.3791 1.80792 8.3677 1.79963C8.3563 1.79237 8.33556 1.78304 8.32105 1.77993C8.30654 1.77682 8.263 1.76335 8.22257 1.74883C8.15311 1.72499 8.08884 1.70529 7.97377 1.67316C7.94578 1.6659 7.89913 1.65243 7.87011 1.64413C7.84212 1.63584 7.77163 1.62133 7.71461 1.612C7.65759 1.60267 7.57155 1.58919 7.52283 1.5809C7.32483 1.54772 6.74327 1.55083 6.52039 1.58608C6.38977 1.60681 6.27366 1.62962 6.21665 1.64517C6.00206 1.70218 5.93882 1.71981 5.90565 1.73328C5.89114 1.7395 5.86626 1.7478 5.84863 1.75194C5.83205 1.75713 5.79162 1.7706 5.76052 1.78304C5.72942 1.79548 5.69106 1.80896 5.67551 1.81414C5.62575 1.82969 5.40598 1.9375 5.25774 2.01836C5.22353 2.03702 5.18829 2.05568 5.17999 2.05983C5.1717 2.06398 5.13749 2.08575 5.10224 2.10855C5.06803 2.1324 5.03175 2.1552 5.02242 2.16142C4.95608 2.20082 4.78814 2.32314 4.73423 2.36979C4.71972 2.38223 4.6824 2.41437 4.6513 2.44132C4.46781 2.59889 4.1734 2.91818 4.08114 3.05813C4.07285 3.0716 4.04693 3.10789 4.02309 3.14002C4.00028 3.17216 3.95467 3.24265 3.92253 3.29656C3.82612 3.45724 3.84064 3.44687 3.71624 3.44791C3.44982 3.44895 3.27566 3.46346 3.04967 3.50389C3.01546 3.51011 2.96466 3.51944 2.93564 3.52358C2.90765 3.52773 2.86307 3.53706 2.83716 3.54432C2.81124 3.55157 2.76252 3.56401 2.72831 3.57334C2.6941 3.58164 2.63812 3.59511 2.60391 3.60444C2.5697 3.61274 2.52823 3.62518 2.51061 3.63347C2.45256 3.65731 2.42353 3.66872 2.34267 3.6967C2.21931 3.73921 1.90624 3.88849 1.84508 3.93514C1.82746 3.94861 1.80983 3.96002 1.80672 3.96002C1.79947 3.96002 1.64812 4.05124 1.6025 4.08441C1.48329 4.16838 1.29047 4.32181 1.2262 4.38193C1.18577 4.42133 1.1329 4.46901 1.10802 4.48871C1.08314 4.5084 1.04271 4.54987 1.01576 4.58201C0.989841 4.61311 0.931788 4.67738 0.887212 4.72507C0.842636 4.77275 0.805317 4.81422 0.805317 4.8194C0.805317 4.82355 0.77007 4.87123 0.727568 4.92514C0.684028 4.97904 0.615609 5.07753 0.574143 5.14491C0.533714 5.21229 0.491211 5.27967 0.481881 5.29522C0.472551 5.31077 0.447671 5.35846 0.425902 5.40096C0.273514 5.70678 0.255891 5.74617 0.236194 5.82081C0.231011 5.83739 0.222718 5.86331 0.216498 5.87782C0.182288 5.96179 0.172958 5.99082 0.128382 6.15772C0.120089 6.18882 0.105576 6.24065 0.096246 6.27175C0.0817329 6.32566 0.0703297 6.38164 0.0340468 6.5983C0.0039839 6.77453 -0.00845593 7.10626 0.00605721 7.34676C0.0133138 7.46494 0.0257536 7.59452 0.0340468 7.63288C0.0423401 7.67227 0.04856 7.71892 0.04856 7.73862C0.04856 7.75728 0.0547799 7.79563 0.0630731 7.82258C0.0713664 7.85057 0.0858795 7.9107 0.0952094 7.95631C0.112832 8.03613 0.131492 8.10766 0.154299 8.17401C0.159482 8.1906 0.167775 8.21859 0.172958 8.23621C0.184362 8.27664 0.203021 8.33054 0.220644 8.37408C0.228938 8.39274 0.235158 8.41451 0.235158 8.42281C0.235158 8.4311 0.263147 8.49641 0.297357 8.56897C0.331566 8.6405 0.359556 8.70374 0.359556 8.70996C0.359556 8.71514 0.371996 8.74106 0.386509 8.76801C0.402059 8.79496 0.427975 8.84265 0.444561 8.87375C0.500541 8.97534 0.52853 9.02303 0.582436 9.10181C0.611463 9.14535 0.638416 9.18682 0.642562 9.19511C0.673662 9.26146 0.938008 9.57764 1.08521 9.72381C1.22412 9.86168 1.39932 10.0099 1.52786 10.097C1.53927 10.1053 1.58073 10.1343 1.61805 10.1613C1.65537 10.1882 1.70928 10.2224 1.73623 10.238C1.76318 10.2525 1.83471 10.295 1.89691 10.3313C1.95807 10.3676 2.01198 10.3976 2.01613 10.3976C2.02027 10.3976 2.0607 10.4163 2.10735 10.4381C2.24315 10.5034 2.28566 10.522 2.30017 10.522C2.30846 10.522 2.31883 10.5262 2.32401 10.5314C2.33023 10.5365 2.35097 10.5459 2.37066 10.5511C2.39036 10.5573 2.43286 10.5718 2.46396 10.5842C2.54275 10.6143 2.60598 10.635 2.66093 10.6464C2.68684 10.6526 2.74075 10.6661 2.78014 10.6775C2.85271 10.6993 2.87759 10.7045 3.0704 10.7356C3.12742 10.7449 3.18962 10.7584 3.20828 10.7656L3.24145 10.7802V11.3348C3.24145 11.8728 3.24041 11.8904 3.22176 11.9008C3.20828 11.907 2.99369 11.9111 2.59665 11.9111C2.26389 11.9111 1.98606 11.9153 1.97881 11.9194C1.96948 11.9267 1.96637 12.0179 1.96844 12.3424L1.97155 12.756L2.59251 12.7591C3.0279 12.7602 3.21761 12.7643 3.22694 12.7726C3.23834 12.7819 3.24145 12.9001 3.24352 13.3925L3.24663 14H3.66648H4.08632L4.08943 13.3925C4.09151 12.9001 4.09462 12.7819 4.10602 12.7726C4.11535 12.7643 4.31335 12.7602 4.77155 12.7591L5.42361 12.756V12.3362V11.9163L4.77051 11.9111C4.41183 11.908 4.1112 11.9018 4.10498 11.8977C4.09462 11.8914 4.09151 11.767 4.09151 11.3358C4.09151 10.7034 4.0801 10.7708 4.19517 10.7501C4.23249 10.7439 4.28847 10.7335 4.31957 10.7273C4.35067 10.7211 4.39317 10.7148 4.41287 10.7117C4.43257 10.7097 4.47403 10.7014 4.5041 10.6931C4.61916 10.6599 4.67929 10.6433 4.71868 10.6309C4.74149 10.6226 4.80887 10.6019 4.869 10.5842C4.92912 10.5656 4.98303 10.5469 4.98821 10.5428C4.99443 10.5386 5.02864 10.522 5.06596 10.5075C5.13749 10.4775 5.22975 10.436 5.27536 10.4121C5.28988 10.4039 5.3075 10.3976 5.31476 10.3976C5.32305 10.3976 5.48373 10.3064 5.60502 10.2318C5.61331 10.2266 5.64752 10.2048 5.68173 10.1851C5.71491 10.1644 5.78229 10.1167 5.83101 10.0783C5.8787 10.04 5.95437 9.98193 5.99688 9.9498C6.20628 9.79015 6.59399 9.36201 6.71735 9.15468C6.73601 9.12462 6.75778 9.08834 6.76607 9.0759C6.77437 9.06242 6.80132 9.01888 6.82516 8.97949C6.849 8.9401 6.87699 8.90381 6.88736 8.89967C6.89773 8.89552 6.96926 8.89137 7.04597 8.88826C7.25641 8.88204 7.50002 8.86649 7.56948 8.85405C7.60369 8.84783 7.67833 8.83539 7.73534 8.82606C7.79236 8.81673 7.85767 8.80326 7.88047 8.796C7.90328 8.78874 7.96133 8.77216 8.01006 8.76076C8.05878 8.74832 8.14482 8.7224 8.20184 8.70167C8.25885 8.68197 8.32001 8.66124 8.3366 8.65709C8.35422 8.65294 8.37703 8.64361 8.38843 8.63843C8.39984 8.63221 8.4299 8.61873 8.45582 8.60837C8.51283 8.5866 8.82279 8.43421 8.86529 8.40726C8.88292 8.39689 8.91505 8.37823 8.93682 8.36579C8.98036 8.34195 9.12653 8.24554 9.17629 8.20822C9.19288 8.19474 9.23745 8.16053 9.27581 8.13254C9.49247 7.96979 9.66144 7.80703 9.87603 7.5572C9.90195 7.52714 9.92683 7.495 9.93201 7.48567C9.93719 7.47634 9.97555 7.42451 10.016 7.3706C10.0958 7.26486 10.1621 7.16535 10.1829 7.12181C10.187 7.11351 10.2067 7.08034 10.2264 7.04924C10.2824 6.96216 10.4161 6.68641 10.4514 6.58793C10.4607 6.5589 10.4731 6.52677 10.4783 6.51537C10.4835 6.50396 10.4918 6.48012 10.497 6.46353C10.5022 6.44591 10.5167 6.40652 10.5291 6.37542C10.5416 6.34432 10.554 6.30907 10.5561 6.29767C10.5592 6.28626 10.5675 6.25309 10.5758 6.2251C10.6494 5.95661 10.6691 5.84258 10.7043 5.48908C10.7199 5.33151 10.7178 4.98526 10.7002 4.88782C10.6919 4.84221 10.6846 4.77793 10.6846 4.7458C10.6846 4.71366 10.6794 4.67427 10.6743 4.65976C10.668 4.64421 10.6597 4.59652 10.6535 4.55298C10.6483 4.50944 10.639 4.45243 10.6318 4.42651C10.6255 4.40059 10.6131 4.35187 10.6048 4.31766C10.582 4.22332 10.4918 3.94861 10.4617 3.88227C10.4472 3.84909 10.4358 3.81903 10.4358 3.81385C10.4358 3.78897 10.2834 3.48212 10.2586 3.45724C10.2534 3.45205 10.2492 3.44065 10.2492 3.43236C10.2492 3.42407 10.242 3.40955 10.2326 3.39919C10.1984 3.36083 10.2109 3.32662 10.2855 3.25509C10.3239 3.21777 10.3819 3.16179 10.4141 3.13069C10.4462 3.09856 10.5094 3.03843 10.555 2.99593C10.6318 2.92544 10.9738 2.60096 11.036 2.5398C11.0506 2.52529 11.0962 2.48382 11.1356 2.4465C11.176 2.41022 11.3087 2.28375 11.431 2.16557C11.5533 2.04843 11.6871 1.92196 11.7265 1.88567C11.7928 1.82451 11.9017 1.72188 12.1235 1.50833C12.1712 1.46272 12.2178 1.4254 12.2272 1.4254C12.2437 1.4254 12.2448 1.46686 12.25 1.93854L12.2551 2.45168L12.676 2.45479L13.0979 2.45687L13.1031 2.43406C13.1073 2.42059 13.1104 1.86805 13.1104 1.20563V0H11.8509H10.5913V0.422955ZM7.36629 2.42059C7.556 2.45065 7.65241 2.46827 7.68351 2.47967C7.70113 2.48589 7.73327 2.49419 7.75608 2.49833C7.81517 2.50974 7.90224 2.53462 7.96859 2.56053C7.99969 2.57194 8.05567 2.59267 8.09299 2.60615C8.13031 2.61962 8.19769 2.64969 8.2433 2.67353C8.28892 2.69633 8.32934 2.71603 8.33453 2.71603C8.35319 2.71603 8.61235 2.87982 8.7098 2.95239C8.96689 3.14624 9.13275 3.31211 9.31831 3.5609C9.38362 3.64902 9.51424 3.85531 9.53705 3.90818C9.54119 3.91648 9.54845 3.93099 9.55363 3.93928C9.55882 3.94758 9.56607 3.96209 9.56918 3.97038C9.57229 3.97867 9.57955 3.99319 9.58473 4.00148C9.61065 4.04709 9.67388 4.19948 9.68943 4.25546C9.69462 4.27205 9.70809 4.31248 9.7195 4.34358C9.74852 4.41925 9.79725 4.60585 9.8242 4.74269C9.88121 5.03606 9.86566 5.58341 9.79414 5.84672C9.78688 5.87264 9.77444 5.91929 9.76615 5.95039C9.75785 5.98149 9.74645 6.02088 9.74023 6.0385C9.73401 6.05509 9.72468 6.08308 9.72053 6.1007C9.6998 6.17223 9.64797 6.31218 9.62205 6.36505C9.6065 6.39615 9.58577 6.43865 9.57644 6.45835C9.56711 6.47805 9.54016 6.52884 9.51631 6.57031C9.49143 6.61281 9.47174 6.64909 9.47174 6.6522C9.47174 6.66983 9.30484 6.90411 9.20843 7.02332C9.13482 7.11248 8.92957 7.31877 8.86529 7.36853C8.83108 7.39445 8.79895 7.42036 8.79273 7.42658C8.77614 7.44524 8.66626 7.5261 8.58021 7.58312C8.4921 7.64117 8.40502 7.68886 8.24849 7.76453C8.18836 7.79356 8.12616 7.82362 8.11061 7.83191C8.09402 7.84021 8.07433 7.84746 8.06707 7.84746C8.05878 7.84746 8.03701 7.85368 8.01835 7.86198C7.84419 7.93454 7.58814 7.99363 7.29269 8.03095C7.22946 8.03821 7.22427 8.02577 7.24604 7.92729C7.28751 7.74691 7.29476 7.70544 7.29476 7.67123C7.29476 7.65154 7.29995 7.61836 7.30617 7.59867C7.31446 7.57171 7.33623 7.21718 7.33519 7.11662C7.33519 7.01607 7.31446 6.6916 7.30617 6.6605C7.29995 6.63769 7.29476 6.59726 7.29476 6.56927C7.29476 6.54232 7.28855 6.4936 7.28025 6.46042C7.27196 6.42829 7.25745 6.36194 7.24812 6.31322C7.22427 6.19297 7.14756 5.93691 7.0978 5.81459C7.08536 5.78349 7.06774 5.73995 7.05944 5.71714C7.02316 5.62073 6.90602 5.38438 6.84278 5.27967C6.8179 5.23821 6.79717 5.20193 6.79717 5.19882C6.79717 5.19363 6.6707 5.00703 6.64997 4.98112C6.64582 4.9749 6.6199 4.94069 6.59295 4.90337C6.45093 4.70848 6.13579 4.38401 5.96267 4.25546C5.93986 4.23784 5.89632 4.20467 5.86729 4.18082C5.81028 4.13521 5.69106 4.05331 5.6807 4.05331C5.67759 4.05331 5.65789 4.04087 5.63716 4.02429C5.61642 4.00874 5.58843 3.99008 5.57392 3.98178C5.55941 3.97349 5.51068 3.9455 5.46404 3.91855C5.41739 3.8916 5.33342 3.84806 5.27744 3.8211C5.22146 3.79415 5.16652 3.7672 5.15719 3.76201C5.14786 3.75683 5.09602 3.7361 5.04315 3.7164C4.99029 3.69567 4.92809 3.67183 4.90528 3.6625C4.84619 3.63969 4.79436 3.62103 4.77362 3.61377C4.76326 3.61066 4.75497 3.60237 4.75497 3.59511C4.75497 3.55261 5.11054 3.16283 5.23805 3.06435C5.26189 3.04672 5.3272 2.99696 5.38318 2.95343C5.43916 2.90989 5.5055 2.86324 5.52831 2.84976C5.55215 2.83628 5.61228 2.8 5.66204 2.76994C5.7118 2.74091 5.75637 2.71603 5.76259 2.71603C5.76778 2.71603 5.7854 2.70877 5.79991 2.70048C5.87455 2.66005 6.02383 2.59163 6.03938 2.59163C6.04974 2.59163 6.06633 2.58438 6.07773 2.57608C6.0881 2.56779 6.1078 2.56053 6.12127 2.56053C6.13475 2.56053 6.15445 2.55535 6.16585 2.54913C6.22805 2.51699 6.55874 2.44236 6.74016 2.42059C6.90498 2.40193 7.24293 2.40089 7.36629 2.42059ZM3.4747 4.3612C3.47159 4.38919 3.46226 4.43377 3.45397 4.46279C3.43634 4.52914 3.41146 4.68671 3.39177 4.85154C3.37414 5.00289 3.37103 5.44139 3.38658 5.54609C3.3928 5.58341 3.40213 5.65494 3.40732 5.70678C3.41665 5.79904 3.42805 5.85502 3.46952 6.0385C3.48092 6.0893 3.49543 6.1515 3.50061 6.17638C3.5058 6.20022 3.51513 6.22925 3.52135 6.23961C3.52653 6.25102 3.53171 6.26864 3.53171 6.28004C3.53171 6.29145 3.53897 6.31425 3.54726 6.3298C3.55556 6.34639 3.56281 6.36816 3.56281 6.37749C3.56281 6.38786 3.56903 6.41066 3.57733 6.42932C3.58562 6.44798 3.5991 6.48219 3.60739 6.505C3.66855 6.66464 3.67685 6.6833 3.79502 6.92484C3.81057 6.95594 3.83234 6.99534 3.84271 7.01296C3.85411 7.02954 3.86759 7.05339 3.87381 7.06479C3.90387 7.12492 4.09773 7.41414 4.14541 7.47012C4.17029 7.49915 4.20865 7.5458 4.23145 7.57379C4.33823 7.70337 4.4844 7.85368 4.63575 7.98845C4.7135 8.05583 4.96541 8.25176 4.97681 8.25176C4.97992 8.25176 5.01827 8.27664 5.06285 8.3067C5.13542 8.35646 5.18414 8.38549 5.33549 8.46738C5.40909 8.50781 5.52002 8.56275 5.52624 8.56275C5.52935 8.56275 5.56148 8.57623 5.59673 8.59178C5.69003 8.63428 5.71594 8.64465 5.78644 8.66849C5.82064 8.6799 5.86315 8.69545 5.87973 8.7027C5.89736 8.70996 5.92016 8.71825 5.93157 8.72033C5.9637 8.72551 5.96267 8.75868 5.92846 8.79496C5.91187 8.81259 5.8704 8.86442 5.83619 8.91003C5.71491 9.07071 5.39976 9.35372 5.21317 9.47086C5.17688 9.49263 5.13542 9.51959 5.11987 9.52892C5.10432 9.53928 5.08462 9.55068 5.07633 9.55483C5.06803 9.55794 5.04212 9.57349 5.01931 9.588C4.96748 9.62014 4.90839 9.65124 4.89802 9.65124C4.89388 9.65124 4.85863 9.66575 4.82027 9.68338C4.78088 9.701 4.73112 9.72381 4.70832 9.73417C4.671 9.7518 4.49166 9.81088 4.35378 9.85235C4.32475 9.86168 4.28847 9.86894 4.27292 9.86894C4.25841 9.86894 4.21694 9.87516 4.1817 9.88345C4.01998 9.92077 3.95882 9.92595 3.67685 9.92595C3.50269 9.92595 3.36378 9.92077 3.3192 9.91351C3.27981 9.90626 3.21139 9.89589 3.16889 9.88967C3.03101 9.86894 2.87759 9.83058 2.77496 9.79119C2.58836 9.71966 2.48677 9.67716 2.47329 9.66575C2.465 9.65746 2.45256 9.65124 2.44738 9.65124C2.43286 9.65124 2.28773 9.5766 2.25041 9.55068C2.23382 9.53928 2.18303 9.50715 2.13742 9.48019C2.0918 9.45324 2.04308 9.42007 2.02857 9.40763C2.01405 9.39415 1.98399 9.37134 1.96222 9.35683C1.92801 9.33402 1.84404 9.26353 1.70306 9.1381C1.68958 9.12669 1.65952 9.09352 1.63464 9.06553C1.6108 9.03651 1.56622 8.98778 1.53719 8.95668C1.42524 8.83954 1.24278 8.56379 1.14741 8.37097C1.05826 8.18956 0.974291 7.97394 0.950448 7.86716C0.945265 7.84228 0.933862 7.79148 0.924532 7.75417C0.907945 7.68367 0.900689 7.64324 0.871662 7.46805C0.848856 7.32292 0.848856 6.89063 0.871662 6.78178C0.880992 6.74032 0.888249 6.68952 0.888249 6.66879C0.888249 6.63354 0.905872 6.55061 0.935935 6.44176C0.944228 6.41274 0.950448 6.37956 0.950448 6.36712C0.950448 6.34639 0.969108 6.28937 0.992951 6.23547C0.997097 6.22407 1.01161 6.18467 1.02405 6.14735C1.03649 6.11003 1.06448 6.04161 1.08625 5.99496C1.10802 5.94832 1.1329 5.89234 1.14223 5.87057C1.17748 5.78556 1.30395 5.58341 1.42524 5.41548C1.53927 5.25791 1.77251 5.02673 1.97362 4.8702C2.11254 4.76342 2.32505 4.63488 2.48469 4.56231C2.65782 4.48456 2.78429 4.43584 2.85789 4.42133C2.87759 4.41718 2.89936 4.41096 2.90454 4.40681C2.91491 4.39956 2.9968 4.3809 3.15126 4.34876C3.2373 4.33114 3.35859 4.31662 3.4322 4.31351L3.48195 4.31248L3.4747 4.3612ZM4.45019 4.41096C4.47818 4.42029 4.52483 4.4348 4.55282 4.4431C4.58184 4.45243 4.61916 4.4659 4.63575 4.47316C4.65337 4.48042 4.68758 4.49493 4.7135 4.50426C4.76533 4.52395 5.00169 4.63799 5.08151 4.68256C5.18932 4.74269 5.35 4.85465 5.47129 4.9552C5.57081 5.03813 5.80509 5.27967 5.86937 5.36468C5.90254 5.41029 5.93364 5.44969 5.93675 5.4528C5.9834 5.48908 6.23738 5.93277 6.26226 6.02295C6.26641 6.03747 6.27574 6.06235 6.28403 6.07997C6.35348 6.23754 6.43642 6.54128 6.45508 6.71233C6.46026 6.75794 6.46959 6.82325 6.47477 6.85746C6.48929 6.93832 6.48929 7.31048 6.47477 7.38201C6.46855 7.41311 6.46026 7.47531 6.45508 7.52092C6.44367 7.61836 6.42501 7.71788 6.39391 7.83088C6.36178 7.94698 6.35867 7.95113 6.31616 7.94076C6.2975 7.93662 6.27677 7.9304 6.27055 7.92625C6.26433 7.92314 6.23945 7.91588 6.21457 7.9107C6.17311 7.90137 6.10261 7.87856 6.05596 7.85887C6.04456 7.85368 6.0145 7.84228 5.98858 7.83191C5.92431 7.80807 5.6921 7.69404 5.6413 7.6619C5.6185 7.64739 5.5791 7.62458 5.55319 7.61111C5.52727 7.59659 5.48788 7.57068 5.46507 7.55305C5.44227 7.53439 5.4008 7.50433 5.37281 7.48464C5.29921 7.43488 5.12505 7.28352 5.03797 7.19334C4.84619 6.99534 4.73942 6.85331 4.57873 6.58275C4.57355 6.57445 4.55904 6.54646 4.54763 6.52055C4.53519 6.49463 4.51446 6.45317 4.50099 6.42725C4.48751 6.40133 4.45952 6.3381 4.43879 6.2873C4.41805 6.23547 4.39628 6.18467 4.3911 6.17327C4.38592 6.16187 4.37555 6.12869 4.36726 6.1007C4.35896 6.07168 4.34445 6.02088 4.33512 5.98667C4.32475 5.95246 4.31335 5.90581 4.3092 5.88301C4.30506 5.8602 4.29676 5.82081 4.28951 5.79489C4.26463 5.6933 4.247 5.55646 4.2356 5.37712C4.22627 5.21851 4.22627 5.15631 4.24079 4.99148C4.25011 4.88264 4.26152 4.77586 4.26774 4.75305C4.27292 4.73025 4.28432 4.67427 4.29365 4.62866C4.31439 4.52292 4.34134 4.42444 4.35378 4.40785C4.36622 4.39126 4.38799 4.3923 4.45019 4.41096Z"
                      fill="#A4A4A4"
                    />
                  </svg>
                </div>
                <div className="flex flex-col ml-3">
                  <p className="textCardHeading156 text-left">Tutor Gender</p>
                  <p className="textPera156 text-left">{apply.teacherGender}</p>
                </div>
              </div>
              <div>
                <div className="flex flex-row mt-8 items-center">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="14"
                      viewBox="0 0 11 14"
                      fill="none"
                    >
                      <path
                        d="M10.5517 2.7385C10.5512 2.73637 10.5511 2.73454 10.5504 2.73235L9.8541 0.482428C9.79031 0.276256 9.63754 0.115694 9.43498 0.0418663C9.23233 -0.0320163 9.01222 -0.00729763 8.83101 0.109569C8.83101 0.109569 8.83098 0.109569 8.83098 0.109597L6.85318 1.38502C6.85059 1.38668 6.84837 1.38849 6.84608 1.39024C6.77668 1.43705 6.72068 1.50508 6.68986 1.58982L5.66565 4.40726L5.23315 3.21751C5.23313 3.21743 5.2331 3.21734 5.23307 3.21726C5.23304 3.21718 5.23302 3.21713 5.23299 3.21704L4.67201 1.67385C4.67198 1.67379 4.67198 1.67374 4.67195 1.67368C4.67192 1.67363 4.6719 1.67357 4.67187 1.67352L4.29784 0.644576C4.11734 0.148124 3.56702 -0.10877 3.07122 0.0718897L0.630226 0.961435C0.390012 1.04896 0.198196 1.22492 0.0901607 1.4569C-0.0178742 1.68889 -0.0291945 1.94912 0.0582233 2.18958L1.57309 6.35686C1.14412 6.4515 0.822097 6.83494 0.822097 7.29248V11.9467C0.822097 13.0789 1.74207 14 2.87287 14H8.0428C9.1736 14 10.0936 13.0789 10.0936 11.9467V7.29246C10.0936 6.82805 9.76184 6.43988 9.3232 6.35268L10.544 2.99433C10.5741 2.91156 10.5762 2.82198 10.5517 2.7385ZM9.12383 0.897697L9.5222 2.18496L8.75735 1.90624C8.75729 1.90621 8.75726 1.90621 8.75721 1.90619C8.75715 1.90616 8.7571 1.90616 8.75704 1.90613L7.99224 1.62742L9.12383 0.897697ZM7.32041 2.2566L8.09123 2.5375L6.71105 6.33422H5.83811L7.32041 2.2566ZM0.829069 1.90865C0.812226 1.8623 0.824722 1.82317 0.833636 1.804C0.842577 1.78481 0.864479 1.75011 0.910772 1.73324L3.35177 0.843665C3.36717 0.83806 3.38292 0.835408 3.39839 0.835408C3.45428 0.835408 3.50684 0.869943 3.52702 0.92545L3.76083 1.56863L2.92576 1.87296C2.71289 1.95057 2.60313 2.18621 2.68059 2.3993C2.74124 2.56607 2.89852 2.66962 3.06606 2.66962C3.11262 2.66962 3.16001 2.66164 3.2063 2.64477L4.04141 2.34043L4.32198 3.11223L2.97301 3.60382C2.76014 3.68142 2.65038 3.91707 2.72784 4.13019C2.78849 4.29696 2.94574 4.40051 3.11331 4.40051C3.15987 4.40051 3.20729 4.39252 3.25355 4.37565L4.60255 3.88407L4.8831 4.65584L4.048 4.96015C3.83512 5.03775 3.72537 5.2734 3.80283 5.48652C3.86348 5.65328 4.02073 5.75683 4.1883 5.75683C4.23486 5.75683 4.28228 5.74885 4.32854 5.73198L5.16362 5.42767L5.22916 5.60798L4.96513 6.33428H2.43783L0.829069 1.90865ZM9.27329 11.9467C9.27329 12.626 8.72131 13.1787 8.04283 13.1787H2.8729C2.19442 13.1787 1.64243 12.626 1.64243 11.9467V7.29246C1.64243 7.21699 1.70377 7.15557 1.77915 7.15557H9.13657C9.21196 7.15557 9.27329 7.21699 9.27329 7.29246V11.9467ZM8.45697 6.33422H7.58403L8.86207 2.8184L9.63292 3.0993L8.45697 6.33422Z"
                        fill="#A4A4A4"
                      />
                    </svg>
                  </div>
                  <p className="textCardHeading156 ml-3">Level of Education</p>
                </div>

                <div className="flex flex-col ">
                  <div className="ml-5">
                    <h1 className="textPera156667 text-left mt-2">Hons</h1>
                    <p className="textPera156 mt-1 text-left">
                      Institute: {apply.teacherHonsInstitute}
                    </p>
                    <p className="textPera156 mt-1 text-left">
                      Semester / Year: {apply.teacherHonsSemester}
                    </p>
                  </div>

                  {/* <p className='textPera156'>Tongi, Dhaka</p> */}
                </div>
              </div>
            </button>
          </div>
        ))}

        {isOpen && selectedItem && (
          <div className="container max-w-[1000px] mx-auto">
            <div className="contentApplication bg-white rounded-xl py-5 border border-gray-200">
              <div className="flex flex-row  justify-between px-10 ">
                <div>
                  <h1 className="modalTittleAppli">Tutor Details</h1>
                </div>
                <div className="flex justify-between">
                  <div>
                    <div className="flex justify-end items-center">
                      <button
                        onClick={() => setIsOpen(false)}
                        className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="h-2 mt-10 w-full"></hr>

              {/* Display data from selectedItem in the modal */}
              <div className="px-10">
                <div className="w-full">
                  <button onClick={handlePrint} className="text-right download">
                    Download
                  </button>
                </div>
                <div className="h-[600px] overflow-y-auto">
                  <div id="admissionForm">
                    <div className="rounded-lg border-2 mt-5">
                      <div className="px-5 py-3 flex justify-between items-center">
                        <h1 className="applicationModalOne">
                          Personal Information
                        </h1>
                      </div>
                      <hr className="h-2"></hr>
                      <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Name :</span>{" "}
                            {selectedItem.teacherName}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Gender :</span>{" "}
                            {selectedItem.teachercity}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Religion:</span>{" "}
                            {selectedItem.teacherReligion}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Phone :</span>{" "}
                            {selectedItem.teacherPhone}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Emergency Number :</span>{" "}
                            {selectedItem.emergencyNmbr}
                          </h1>
                        </div>

                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">City :</span>{" "}
                            {selectedItem.teachercity}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Area :</span>{" "}
                            {selectedItem.teacherarea}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera"></span>NID / Birth
                            Certificate / Passport{" "}
                          </h1>
                          <div className="flex w-20 flex-row justify-between items-center">
                            <a
                              target="_blank"
                              href={selectedItem.teacherPersonalData1}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherPersonalData2}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherPersonalData3}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="rounded-lg border-2 mt-5">
                      <div className="px-5 py-3 flex justify-between items-center">
                        <h1 className="applicationModalOne">
                          Educational Information
                        </h1>
                      </div>
                      <hr className="h-2"></hr>
                      <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Level of Education :
                            </span>{" "}
                            Masters
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Institute :</span>{" "}
                            {selectedItem.teacherMastersInstitute}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Certificate</span>
                          </h1>
                          <div className="flex w-20 flex-row justify-between items-center">
                            <a
                              target="_blank"
                              href={selectedItem.teacherMastersFileUrls1}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherMastersFileUrls2}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherMastersFileUrls3}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>

                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Semester/Year :
                            </span>{" "}
                            {selectedItem.teacherMastersSemester}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Major/Subject :
                            </span>{" "}
                            {selectedItem.teacherMastersMejor}
                          </h1>
                        </div>
                      </div>
                      <hr className="h-2 mt-3 mx-5"></hr>
                      <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Level of Education :
                            </span>{" "}
                            Hons
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Institute :</span>{" "}
                            {selectedItem.teacherHonsInstitute}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Certificate</span>
                          </h1>
                          <div className="flex w-20 flex-row justify-between items-center">
                            <a
                              target="_blank"
                              href={selectedItem.teacherHonsFileUrls1}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherHonsFileUrls2}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherHonsFileUrls3}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>

                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Semester/Year :
                            </span>{" "}
                            {selectedItem.teacherHonsSemester}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Major/Subject :
                            </span>{" "}
                            {selectedItem.teacherHonsMajor}
                          </h1>
                        </div>
                      </div>
                      <hr className="h-2 mt-3 mx-5"></hr>
                      <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Level of Education :
                            </span>
                            HSC
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Institute :</span>{" "}
                            {selectedItem.teacherHSCinstitute}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Certificate :</span>
                          </h1>
                          <div className="flex w-20 flex-row justify-between items-center">
                            <a
                              target="_blank"
                              href={selectedItem.teacherHSCFile1}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherHSCFile2}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                            <a
                              target="_blank"
                              href={selectedItem.teacherHSCFile3}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="25"
                                viewBox="0 0 19 25"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                  fill="#E5252A"
                                />
                                <path
                                  opacity="0.302"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>

                        <div className="w-full pb-5">
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">Group :</span>{" "}
                            {selectedItem.teacherHSCgroup}
                          </h1>
                          <h1 className="text-left modalDetailsText mt-5">
                            <span className="modalTextPera">
                              Passing Result :
                            </span>{" "}
                            {selectedItem.teacherHSCresult}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-lg border-2 mt-5">
                    <div className="px-5 py-3 flex justify-between items-center">
                      <h1 className="applicationModalOne">
                        Teaching Experience
                      </h1>
                    </div>
                    <hr className="h-2"></hr>
                    <div className="px-5 py-4">
                      <p className="peraText">
                        {selectedItem.teacherExperience}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Add more elements to display other properties */}
            </div>
          </div>
        )}
      </div>
      <div className="flex justify-center items-center mt-5">
        {showItemCount < mainShortedData.length && (
          <button
            className="w-20
                        flex justify-center items-center
                        bg-orange-400 h-5 text-sm text-white rounded-lg hover:bg-orange-500"
            onClick={handleShowMore}
          >
            Show More
          </button>
        )}
        {isModalOpen && selectedItemTwo && (
          <div className="container max-w-[1000px] mx-auto">
            <div className="p-10 flex justify-center items-center bg-white w-[380px] h-[300px] border-2 border-gray-200 rounded-lg contentApplicationLeed">
              <div className="flex flex-col justify-center items-center p-20">
                <div className="flex justify-end  w-full">
                  <button
                    onClick={() => setModalOpen(false)}
                    className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="68"
                  height="60"
                  viewBox="0 0 68 60"
                  fill="none"
                >
                  <path
                    d="M66.2224 49.7273L39.4837 3.43836C38.888 2.39399 38.0266 1.52582 36.9869 0.921949C35.9472 0.318077 34.7663 0 33.5639 0C32.3616 0 31.1807 0.318077 30.141 0.921949C29.1013 1.52582 28.2399 2.39399 27.6441 3.43836L0.905452 49.7273C0.309118 50.7702 -0.00308973 51.9514 2.30503e-05 53.1528C0.00313583 54.3541 0.321461 55.5336 0.923191 56.5734C1.52492 57.6133 2.38899 58.477 3.42906 59.0782C4.46912 59.6795 5.64877 59.9973 6.85014 59.9999H60.2777C61.4837 60.0049 62.6694 59.6898 63.7138 59.0868C64.7581 58.4838 65.6238 57.6144 66.2224 56.5674C66.8326 55.531 67.1545 54.3501 67.1545 53.1474C67.1545 51.9446 66.8326 50.7638 66.2224 49.7273ZM64.0584 55.3238C63.683 55.9947 63.1338 56.552 62.4685 56.9372C61.8032 57.3223 61.0464 57.5211 60.2777 57.5126H6.85014C6.08622 57.5083 5.33673 57.3042 4.67614 56.9205C4.01556 56.5368 3.46687 55.987 3.08461 55.3256C2.70235 54.6641 2.49983 53.9142 2.49716 53.1503C2.49449 52.3864 2.69178 51.635 3.06942 50.971L29.7832 4.68201C30.1701 4.03816 30.7171 3.50539 31.3708 3.13551C32.0246 2.76564 32.763 2.57125 33.5142 2.57125C34.2653 2.57125 35.0037 2.76564 35.6575 3.13551C36.3113 3.50539 36.8582 4.03816 37.2452 4.68201L64.0584 50.971C64.4479 51.6301 64.6534 52.3818 64.6534 53.1474C64.6534 53.913 64.4479 54.6646 64.0584 55.3238ZM32.3203 38.3603V17.3425C32.3203 17.0126 32.4513 16.6963 32.6845 16.4631C32.9178 16.2298 33.2341 16.0988 33.5639 16.0988C33.8938 16.0988 34.2101 16.2298 34.4433 16.4631C34.6766 16.6963 34.8076 17.0126 34.8076 17.3425V38.3603C34.8076 38.6901 34.6766 39.0065 34.4433 39.2397C34.2101 39.4729 33.8938 39.6039 33.5639 39.6039C33.2341 39.6039 32.9178 39.4729 32.6845 39.2397C32.4513 39.0065 32.3203 38.6901 32.3203 38.3603ZM36.0512 47.5634C36.0512 48.0553 35.9054 48.5362 35.6321 48.9452C35.3587 49.3543 34.9703 49.6731 34.5158 49.8613C34.0613 50.0496 33.5612 50.0989 33.0787 50.0029C32.5962 49.9069 32.153 49.67 31.8051 49.3222C31.4573 48.9743 31.2204 48.5311 31.1244 48.0486C31.0284 47.5661 31.0777 47.066 31.2659 46.6115C31.4542 46.157 31.773 45.7685 32.182 45.4952C32.5911 45.2219 33.072 45.076 33.5639 45.076C34.2236 45.076 34.8563 45.3381 35.3227 45.8046C35.7892 46.271 36.0512 46.9037 36.0512 47.5634Z"
                    fill="#0E73B7"
                  />
                </svg>
                <p className="reasonTittle mr-5">Reason For Archive</p>

                <select
                  className="select select-primary w-full mt-5"
                  value={selectedReason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                >
                  <option value="">Select a reason</option>
                  <option value="Guardian">Guardian</option>
                  <option value="Processing Speed">Processing Speed</option>
                  <option value="Tutor Finding Speed">
                    Tutor Finding Speed
                  </option>
                  <option value="Couldn't Find Tutor">
                    Couldn't Find Tutor
                  </option>
                  <option value="Miscommunication">Miscommunication</option>
                </select>
                <button
                  onClick={() =>
                    handleMakeCancelled(selectedItemTwo._id, selectedReason)
                  }
                  className="ModalSubmit w-56 mt-5"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {showItemCount > 3 && (
          <button
            className="w-20 bg-orange-300 h-5 text-sm text-white rounded-lg hover:bg-orange-600 ml-5"
            onClick={handleShowLess}
          >
            Show Less
          </button>
        )}
      </div>
    </div>
  );
};

export default PendingVerificationDetails;
